import userIndex from '@/view/user/index'

const userRouter = [
  {
    path: '/user/index/:id.html',
    name: 'user-index',
    component: userIndex,
    meta: {
      title: '品牌主主页'
    }
  }
]

export default userRouter



// WEBPACK FOOTER //
// ./src/router/user/user.js